import { ResourceBuilder } from '../../core/resource-builder'
import type Model from './model'

type PromptsRequestsConfig = {
  list: {
    request: void
    response: string[]
  }
  create: {
    request: {
      prompt: string
      status: string
    }
    response: void
  }
  get: {
    request: void
    response: Model[]
  }
}

export default new ResourceBuilder<PromptsRequestsConfig>('prompts')
